/**
 * Black-Swan i18n Middleware
 *
 * @since: 2017-11-23
 * @author: kdydesign.kim
 */

// 다국어 미들웨어.. 필요한가?

export default function ({isHMR, app, store, route, params, error}) {
  if (isHMR) return

  const locales = store.state.common.locale.locales
  const locale = store.state.common.locale.locale || 'ko'

  if (locales.indexOf(locale) === -1) {
    return error({message: 'This page could not be found.', statusCode: 404})
  }

  // store.commit('common/locale/setLang', locale)

  app.i18n.locale = locale
}
